













import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    PdCreateForm: () => import('@/components/pd/PdCreateForm.vue')
  }
})
export default class PdCreate extends Vue {
  $store!: ExStore

  get isInappBrowser() {
    return this.$store.getters['pd/isInAppBrowser']
  }

  get loginUser() {
    return this.$store.getters['user/userInfo']
  }

  beforeDestroy() {
    if (this.isInappBrowser && this.$route.name !== 'Hangup') {
      this.$router.replace({ name: 'Hangup' })
    }
  }

  handleSubmit() {
    if (this.isInappBrowser && this.$route.name !== 'Hangup') {
      this.$router.replace({ name: 'Hangup' })
    }
  }
}
